export default __webpack_public_path__ + "static/media/volume_max_outline.1c2388f0.svg";